import React from 'react';
import PreLoginPage from '../../../views/core/PreLoginPage';

class DownloadButton extends PreLoginPage {
    constructor(props) {
        super(props);
        this.productDetails = localStorage.getItem('proDetail');
        this.getPDF=this.getPDF.bind(this);
    };

	  getProductDetails(){
		//console.log(JSON.parse(this.productDetails));
	    if(this.productDetails != {} && this.productDetails != undefined){
	      return JSON.parse(this.productDetails);
	    }
	}

    getPDF(){
        window.open(this.getUrlFor("GET_MOCK"),"_blank");
      }


    render() {
        var martop=this.props.className || '';
        var classname = this.getProductDetails()[this.props.id].ClassName;
        //console.log("classname ::: ",classname)
        if(classname=="Class 10"){
            return(
                <div id="DownloadButton" className={" "+martop} >
                <div className="container">			
                    <div className="row">
                        <div class="col-12 text-center">
                            {/* <p>Download Mock Exam Paper</p> */}
                            <button type="button" id="download" onClick={this.getPDF} className="btn btn-primary dwnldBtn widthmax" data-ga="Personalised Learning Program - Class 10 - Download Mock Exam Paper" data-category="PLP" data-label="Download" >{this.rb("mock.download")}</button>      
                        </div>
                    </div>
                </div>
            </div>
            )
        }else{
            return(
                <span style={{display:'none'}}></span>
            )
        }
    }
  }
  
  export default DownloadButton;



// WEBPACK FOOTER //
// ./src/prelogin/src/components/DownloadButton.js